module.exports = __webpack_public_path__ + "img/map.57141335.png";